(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["astra-interactions"] && !Shopify.designMode) return;
  try {
    let astraImageObserver;
function primeAstraImages(root){
if(!('IntersectionObserver' in window))return;
if(!astraImageObserver)astraImageObserver=new IntersectionObserver(entries=>{
entries.forEach(entry=>{if(entry.isIntersecting){entry.target.loading='eager';astraImageObserver.unobserve(entry.target)}});
},{rootMargin:'600px 0px'});
root.querySelectorAll('.slides > .slide:first-child img[loading="lazy"]').forEach(img=>astraImageObserver.observe(img));
}
function shuffleHomeCards(grid){
if(!grid?.hasAttribute('data-home-shuffle'))return;
const cards=[...grid.querySelectorAll(':scope > [data-product-id]')];
for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]]}
cards.forEach(card=>grid.append(card));
}
function initAstra(root=document){
root.querySelectorAll('[data-home-shuffle]').forEach(grid=>{if(!grid.dataset.shuffled){shuffleHomeCards(grid);grid.dataset.shuffled='true'}});
root.querySelectorAll('[data-gallery]').forEach(g=>{
if(g.dataset.ready)return;g.dataset.ready='true';
const track=g.querySelector('.slides'),dots=[...g.querySelectorAll('[data-slide]')];
const slides=[...track.querySelectorAll('.slide')];
function preparePhoto(index){
const slide=slides[index],deferred=slide?.querySelector('[data-deferred-photo]');
if(!deferred)return;
const fragment=deferred.content.cloneNode(true),img=fragment.querySelector('img');
if(img){img.loading='eager';img.decoding='async'}
deferred.replaceWith(fragment);
}
function prepareNeighbours(){
const index=Math.round(track.scrollLeft/track.clientWidth);
preparePhoto(index);preparePhoto(index+1);preparePhoto(index-1);
}
track.addEventListener('touchstart',prepareNeighbours,{passive:true});
track.addEventListener('pointerdown',prepareNeighbours,{passive:true});
track.addEventListener('focusin',prepareNeighbours);
let pending=false,start=0,moved=false;
track.addEventListener('pointerdown',e=>{start=e.clientX;moved=false},{passive:true});
track.addEventListener('pointermove',e=>{if(e.buttons&&Math.abs(e.clientX-start)>10)moved=true},{passive:true});
track.addEventListener('click',e=>{if(moved){e.preventDefault();moved=false}});
dots.forEach((b,i)=>b.addEventListener('click',()=>{preparePhoto(i);preparePhoto(i+1);preparePhoto(i-1);track.scrollTo({left:i*track.clientWidth})}));
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();prepareNeighbours();track.scrollBy({left:track.clientWidth*(e.key==='ArrowRight'?1:-1)})}});
track.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{const i=Math.round(track.scrollLeft/track.clientWidth);prepareNeighbours();dots.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));pending=false})},{passive:true});
});
primeAstraImages(root);
const nav=root.querySelector('.collection-nav'),active=nav?.querySelector('[aria-current="page"]');
if(active)nav.scrollLeft=Math.max(0,active.offsetLeft-nav.offsetLeft-(nav.clientWidth-active.clientWidth)/2);
}
initAstra();document.addEventListener('shopify:section:load',e=>initAstra(e.target));

function initAstraLoading(root=document){
root.querySelectorAll('[data-catalogue]').forEach(catalogue=>{
if(catalogue.dataset.loadingReady)return;
catalogue.dataset.loadingReady='true';
const sentinel=catalogue.querySelector('[data-auto-load]'),grid=catalogue.querySelector('[data-product-grid]');
if(!sentinel||!sentinel.dataset.next)return;
const status=sentinel.querySelector('[data-load-status]'),link=sentinel.querySelector('[data-load-link]');
let busy=false,failed=false,observer;
const seen=new Set([...grid.querySelectorAll('[data-product-id]')].map(c=>c.dataset.productId));
async function loadNext(){
if(busy||!sentinel.dataset.next||!catalogue.isConnected)return;
busy=true;failed=false;link.hidden=true;status.textContent=status.dataset.loading;
const next=sentinel.dataset.next;
try{
const url=new URL(next,location.href);
const preview=new URL(location.href).searchParams.get('preview_theme_id');
if(preview)url.searchParams.set('preview_theme_id',preview);
url.searchParams.set('section_id',catalogue.dataset.sectionId);
const response=await fetch(url,{credentials:'same-origin'});
if(!response.ok)throw new Error('Load failed');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const incoming=doc.querySelector('[data-catalogue]');
if(!incoming)throw new Error('Catalogue missing');
const cards=[...incoming.querySelectorAll('[data-product-grid] > [data-product-id]')];
if(grid.hasAttribute('data-home-shuffle')){
for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]]}
}
const newCards=cards.filter(card=>!seen.has(card.dataset.productId));
const following=incoming.querySelector('[data-auto-load]')?.dataset.next||'';
if(!newCards.length&&following)throw new Error('No new products');
newCards.forEach(card=>{seen.add(card.dataset.productId);grid.append(card)});
initAstra(grid);
sentinel.dataset.next=following===next?'':following;
status.textContent='';
if(sentinel.dataset.next){link.href=sentinel.dataset.next}else{link.remove();observer?.disconnect()}
}catch(error){failed=true;status.textContent=status.dataset.error;link.hidden=false}
finally{busy=false}
if(!failed&&sentinel.dataset.next&&sentinel.getBoundingClientRect().top<innerHeight+800)loadNext();
}
link.addEventListener('click',e=>{e.preventDefault();loadNext()});
if('IntersectionObserver' in window){
link.hidden=true;
observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!failed)loadNext()},{rootMargin:'800px 0px'});
observer.observe(sentinel);
}
});
}
initAstraLoading();document.addEventListener('shopify:section:load',e=>initAstraLoading(e.target));
  } catch(e) { console.error(e); }
})();

})();
